import { Component, OnInit } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { IonIcon } from "@ionic/angular/standalone";

@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.scss'],
  imports: [IonicModule],
})
export class TransactionDetailsComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
